export const INITIAL_FIELD_KEY: string = ''
export const INITIAL_FIELD_VALUE: string = ''

// Max characters allowed for a custom field name.
export const MAX_CUSTOM_FIELD_NAME_LENGTH = 50

// Max characters allowed for a custom field value.
export const MAX_CUSTOM_FIELD_VALUE_LENGTH = 3000

export const INITIAL_FIELD: Record<string, string> = {
  [INITIAL_FIELD_KEY]: INITIAL_FIELD_VALUE,
}
